export const PrivateGameIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M13.125 10.5C14.5747 10.5 15.75 11.6753 15.75 13.125C15.75 14.5747
       14.5747 15.75 13.125 15.75C11.9076 15.75 10.8838 14.9209 10.5869 13.7969L9.75488 
       13.3809C9.27981 13.1433 8.72019 13.1433 8.24512 13.3809L7.41309 13.7969C7.11615 14.9209 
       6.09237 15.75 4.875 15.75C3.42525 15.75 2.25 14.5747 2.25 13.125C2.25 11.6753 3.42525 10.5 4.875 
       10.5C6.12007 10.5 7.16304 11.3672 7.43262 12.5303L7.74219 12.375C8.53398 11.9791 9.46602 
       11.9791 10.2578 12.375L10.5674 12.5303C10.837 11.3672 11.8799 10.5 13.125 10.5ZM10.1738 
       3C11.8612 3 12.7051 3.00002 13.3154 3.47656C13.9257 3.95308 14.1308 4.77139 14.54 6.4082L14.8594 
       7.6875H16.5C16.8107 7.6875 17.0625 7.93934 17.0625 8.25C17.0625 8.56066 16.8107 8.8125 
       16.5 8.8125H1.5C1.18934 8.8125 0.9375 8.56066 0.9375 8.25C0.9375 7.93934 1.18934 7.6875 
       1.5 7.6875H3.14062L3.45996 6.4082C3.86917 4.77139 4.07427 3.95308 4.68457 3.47656C5.29491 
       3.00002 6.13878 3 7.82617 3H10.1738Z"
      fill="#032615"
    />
  </svg>
)
